<template>
    <div>
        <hts-form-select
            v-model="cValue"
            v-model:text="cText"
            :query="findCategoryVehicle"
            :filterable="true"
            :clearable="true"
            :label="label"
            :required="required"
            :selected-multiple="dataMultiple"
            :multiple="multiple"
            :prop="prop"
            :disabled="disabled"
            :readonly="readonly"
            key-id="_id"
            key-label="name"
            @change="handleChange" />
    </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  api: Object,
  modelValue: { type: [Array, String], default: () => '' },
  prop: { type: String, default: '' },
  multiple: { type: Boolean, default: false },
  dataMultiple: { type: [Array, Object], default: () => [] },
  required: { type: Boolean, default: false },
  name: { type: String, default: '' },
  label: { type: String, default: () => $t('labels.remoocType') },
  disabled: { type: Boolean, default: false },
  readonly: { type: Boolean, default: false }
})

const emits = defineEmits(['update:modelValue', 'update:name', 'click', 'change'])

const cValue = computed({
  get () {
    return modelValue.value
  },
  set (val: any) {
    emits('update:modelValue', val)
  }
})
const { modelValue, name, required, multiple } = toRefs(props)
const findCategoryVehicle = async (s: string) => {
  const api = props.api || $url.vehicle.remoocCategory.find

  const res = await $api(api, { uriParams: { KEY: s } })
  const resData: any = res?.data?.value
  if (resData?.success) {
    return resData.data
  }
  return null
}
const cText = computed({
  get () {
    return name.value || ''
  },
  set (val: any) {
    emits('update:name', val)
  }
})
const information = ref([])

const handleChange = (val: any) => {
  emits('change', val)
}
</script>
